// extracted by mini-css-extract-plugin
export var nav = "archive-modules--nav--1JyA9";